export default function (context, val) {
  let settings = context.rootState.user.setting.items;
  context.dispatch('set_title', 'Добавление платежей', {root: true});
  let date = new Date();

  let category = context.rootGetters['dictionary/paymentType/getById'](settings.DefaultAgreementPaymentType).CategoryId;
  let cash = settings.DefaultAgreementPaymentSource;
  let account = settings.DefaultAgreementPaymentSource;
  switch (category) {
    case 0:
      if (!context.rootState.dictionary.cash.list.filter(i => i.value === cash)[0]) {
        if (context.rootState.dictionary.cash.list[0]) cash = context.rootState.dictionary.cash.list[0].value;
      }
      break;
    case 1:
      if (!context.rootState.dictionary.paymentAccount.list.filter(i => i.value === account)[0]) {
        if (context.rootState.dictionary.paymentAccount.list[0]) account = context.rootState.dictionary.paymentAccount.list[0].value;
      }
      break;
  }
  context.commit('set_form', {
    Id: 0,
    Name: '',
    CertificateId: '',
    CertificateName: '',
    NameLat: '',
    PaymentDirection: settings.DefaultAgreementPaymentDirection,
    PaymentOperationID: settings.DefaultAgreementPaymentOperation,
    RateArticleId: null,
    CategoryId: category,
    PaymentTypeId: settings.DefaultAgreementPaymentType,
    CashId: cash,
    PaymentAccountId: account,
    AccountNumber: '',
    ContragentType: context.rootGetters['dictionary/contragentType/list'](settings.DefaultAgreementPaymentOperation)[0].value,
    ContragentID: null,
    ContragentName: '',
    PartnerLegalEntityId: null,
    Sum: 0,
    BankCommission: 0,
    CurrencyId: 1,
    PaymentDate: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
    DocumentNumber: settings.DefaultAgreementPaymentDirection === 0 ? context.state.system.IncomePaymentNumber : context.state.system.OutcomePaymentNumber,
    Comment: '',
    RegularPaymentTypeId: 0,
    dayMonth: 1,
    dayWeek: 1,
    dayYear: '',
    dayOne: '',
    NotificationsEndDate: '',
    AgreementCodes: [],
  });
  context.dispatch('agreements/add', {
    id: val.id,
    callback: agreement => {
      agreement.requests.forEach(i => {
        i.sum = settings.DefaultAgreementPaymentDirection === 1 ? i.out : i.inp;
      });
      context.commit('set_form', {
        CurrencyId: agreement.AGCurrency,
      });
      context.dispatch('agreement_getCourse', agreement.code);
      if (context.getters.computed_hiddenClient || context.getters.computed_hiddenOperator) context.dispatch('change_ContragentType', 7);
      setTimeout(() => {
        context.commit('set_form', {
          Sum: context.getters['agreements/sum_all'],
        });
        context.commit('set_load', {
          data: false,
        });
      });
    }
  });
}
